import {JsonObject, JsonProperty} from 'json2typescript';
import ServerMessageDto from '@/logic/ark-stats-backend/dto/servermessage/ServerMessageDto';

@JsonObject('ServerMessageListDto')
export default class ServerMessageListDto {
    @JsonProperty('data', [ServerMessageDto])
    data: ServerMessageDto[] = [];
}
